import API from './Api.js';
import Utils from './utils.js';
import router from './Router.js';
import { eventBus, EVENTS } from './EventBus.js';

let googleLoginCb;
let googleLoginErrorCb;

const TITLE_TERMS_2021 = "Termini e condizioni RDS";

class Users {

  constructor() {
    this.paginatore_giochi = false;
    this.paginatore_podcast_preferiti = false;
    this.paginatore_canzoni_preferite = false;
    eventBus.on(EVENTS.RENDER_USER_LOGGED, function () { closeLoginPopup() });
  }

  getAfterLoginRedirectUrl() {
    let redirect = '/profilo';
    let cRedirectUrl = Utils.getCookie('redirect_url')
    if (cRedirectUrl) {
      redirect = cRedirectUrl;
    }
    Utils.eraseCookie('redirect_url');
    return redirect;
  }

  sendMessage(text) {

    this.checkUser(function () {

      var img_src = "https://media.rds.it/web/web-site-brandnew/svg/chat/icon-web.svg";
      let html = window.templates["simple_message_homepage"];
      html = html.replace("{{message}}", text).replace("{{src}}", img_src);

      // appendo il messaggio appena creato
      $("#container_chat").append(html);
      $("#container_chat_mobile").append(html);

      // scrollo all'ultimo messaggio inserito
      setTimeout(function () {
        $("#container_chat").animate({ scrollTop: $('#container_chat').prop("scrollHeight") }, 1000);
        $("#container_chat_mobile").animate({ scrollTop: $('#container_chat_mobile').prop("scrollHeight") }, 1000);
      }, 100);

      // sbianco il campo
      $(".container_messaggio").find("textarea").val("");

      API.post("community/message/send", { text: text }, function (resp) {
        console.log("messaggio inviato al server");

      });

    }, function () {
      router.addNavigation("/login");
    });

  }

  registerMail() {

    eventBus.emit(EVENTS.USER_CLICK_REGISTER_BUTTON);

    var type_login = $("#button_registrati").attr("data-type");

    $(".eye-icon").removeClass("margin-bottom-25");

    $("#error-message-name").html("");
    $("#error-message-email").html("");
    $("#error-message-password").html("");

    $("#error-message-cognome").html("");
    $("#error-message-citta").html("");
    $("#error-message-telefono").html("");
    $("#error-message-data").html("");

    $(".fieldset-name").removeClass("fieldset-error");
    $(".fieldset-email").removeClass("fieldset-error");
    $(".fieldset-password").removeClass("fieldset-error");

    $(".fieldset-cognome").removeClass("fieldset-error");
    $(".fieldset-citta").removeClass("fieldset-error");
    $(".fieldset-telefono").removeClass("fieldset-error");
    $(".fieldset-data").removeClass("fieldset-error");

    let in_error = false;

    let name = $("input#user-name").val();
    let email = $("input#user-email").val();
    let password = $("input#user-password").val();

    let citta = $("input#user-citta").val();
    let cognome = $("input#user-cognome").val();
    let telefono = $("input#user-telefono").val();
    let data = $("input#user-data").val();

    if (name == "") {
      $(".fieldset-name").addClass("fieldset-error");
      $("#error-message-name").html("Nome obbligatorio");
      in_error = true;
    }

    if (cognome == "") {
      $(".fieldset-cognome").addClass("fieldset-error");
      $("#error-message-cognome").html("Cognome obbligatorio");
      in_error = true;
    }

    if (email == "") {
      $(".fieldset-email").addClass("fieldset-error");
      $("#error-message-email").html("Email obbligatoria");
      in_error = true;
    }

    // if(type_login != "fb" && type_login != "google"){
    if (password == "" || password.length < 10) {
      $(".fieldset-password").addClass("fieldset-error");
      $("#error-message-password").html("La password deve essere di almeno 10 caratteri");
      $(".eye-icon").addClass("margin-bottom-25");
      in_error = true;
    }
    // } else{
    // if(password == "" ){
    //     $(".fieldset-password").addClass("fieldset-error");
    //     $("#error-message-password").html("Password obbligatoria");
    //     $(".eye-icon").addClass("margin-bottom-25");
    //     in_error = true;
    // }
    // }



    // extra campi obbligatori



    // if(citta == ""){
    //     $(".fieldset-citta").addClass("fieldset-error");
    //     $("#error-message-citta").html("Città di residenza obbligatoria");
    //     in_error = true;
    // }
    //
    // if(telefono == ""){
    //     $(".fieldset-telefono").addClass("fieldset-error");
    //     $("#error-message-telefono").html("Telefono obbligatorio");
    //     in_error = true;
    // }
    //
    // if(data == ""){
    //     $(".fieldset-data").addClass("fieldset-error");
    //     $("#error-message-data").html("Data di nascita obbligatoria");
    //     in_error = true;
    // }

    // se non ho cliccato la checkbox obligatoria

    let privacy_1 = $('#privacy_1').is(':checked');
    let over_16 = $('#flageta').is(':checked');
    let user_profilation = $('#user_profilation').is(':checked');
    let user_terze_parti = $('#user_terze_parti').is(':checked');


    let user_newsletter = $('#user_newsletter').is(':checked');

    if (!privacy_1) {
      Utils.alertMessage("Devi accettare termini e condizioni prima di procedere con la registrazione");
      in_error = true;
    }
    if (!over_16) {
      Utils.alertMessage("Devi avere almeno 16 anni per registrarti");
      in_error = true;
    }

    if (in_error) {
      return;
    }

    let fbtoken = $("input#fbtoken").val();
    let gtoken = $("input#gtoken").val();

    Utils.showWaitingLoader();

    API.post("community/registerMail", {
      email: email,
      password: password,
      name: name,
      user_newsletter: user_newsletter ? 1 : 0,
      user_profilation: user_profilation ? 1 : 0,
      user_terze_parti: user_terze_parti ? 1 : 0,
      fbtoken: fbtoken,
      gtoken: gtoken,
      citta: citta,
      telefono: telefono,
      data: data,
      cognome: cognome,
      flageta: over_16 ? 1 : 0
    }, function (resp) {

      Utils.hideWaitingLoader();

      if (resp.status == -11 || resp.status == -12) {

        $(".fieldset-email").addClass("fieldset-error");
        $("#error-message-email").html("L'email inserita non è valida");

      } else if (resp.status == -2) {

        $(".fieldset-email").addClass("fieldset-error");
        $("#error-message-email").html("Risulta gi&agrave; presente un utente con la mail inserita");

      } else if (resp.status == -3) {

        $(".fieldset-password").addClass("fieldset-error");
        $("#error-message-password").html("Errore generico; riprovare più tardi");

      } else if (resp.status == -13) {

        $(".fieldset-data").addClass("fieldset-error");
        $("#error-message-data").html(resp.message);

      } else if (resp.status == 1) {

        Utils.alertMessage("La registrazione è avvenuta con successo! </br> Ti abbiamo inviato un'email per verificare il tuo indirizzo. </br>Controlla la casella di posta che hai indicato durante la registrazione e attiva il tuo account.");
        router.addNavigation("/");
        eventBus.emit(EVENTS.REGISTRAZIONE_START);
      } else if (resp.status == 0) {


        // if(type_login == "fb"){
        //     resp.user.type_login = "fb";
        //
        // } else if(type_login == "google"){
        //     resp.user.type_login = "google";
        //
        // }
        user.saveLocalUser(resp.user);
        eventBus.emit(EVENTS.RENDER_USER_LOGGED, resp.user);
        router.addNavigation("/profilo");
        Utils.setCookie("rds_user_session", resp.user.rds_auth_token, 1);
        eventBus.emit(EVENTS.USER_REGISTER_OK);

      }

    }, function () {
      Utils.hideWaitingLoader();
    });

  }

  createLoginEventParams() {
    return {
      url: location.href
    }
  }

  loginMail() {
    return new Promise((resolve, reject) => {

      $(".error-message-name").html("");
      $("#error-message-password").html("");
      $("#error-message-name").html("");

      $(".fieldset-email").removeClass("fieldset-error");
      $(".fieldset-password").removeClass("fieldset-error");
      $(".fieldset-name").removeClass("fieldset-error");

      let in_error = false;

      let email = $("input#user-email").val();
      let password = $("input#user-password").val();
      let name = $("input#user-name").val();

      if ($("input#user-email").val() == "") {
        $(".fieldset-email").addClass("fieldset-error");
        $(".error-message-name").html("Email errata");
        in_error = true;
      }

      if ($("input#user-password").val() == "") {
        $(".fieldset-password").addClass("fieldset-error");
        $("#error-message-password").html("Password errata");
        in_error = true;
      }

      if ($("input#user-name").val() == "") {
        $(".fieldset-name").addClass("fieldset-error");
        $("#error-message-name").html("Nome errato");
        in_error = true;
      }

      if (in_error) {
        return;
      }

      Utils.showWaitingLoader();

      API.post("community/login/mail", { email: email, password: password, name: name }, function (resp) {

        Utils.hideWaitingLoader();

        if (resp.status != 0) {

          if (resp.status == -3) {
            $(".error-message-password").html(resp.message);
            return;
          } else if (resp.status == -6) {
            // console.log(resp.status);
            // $(".rds-modal-popup-box").css("height", "350px");
            // $("#rds-popup-content").html(window.templates["conferma-privacy-popup"]);
            // RDSMODALPOPUP.open();
            // $(document).on('submit', '#formconfermaprivacy', function (e) {
            //     e.preventDefault();
            //     USER.confirmPrivacy(email, password);
            // });
          } else if (resp.status == -2021) {

            closeLoginPopup();

            Utils.confirmCustom(TITLE_TERMS_2021, window.templates["termini_condizioni_popup_2021"], () => {

              var profilo_spunta_newsletter = $('#popup_2021_profilo_spunta_newsletter').is(':checked');
              var profilo_spunta_privacy_2 = $('#popup_2021_profilo_spunta_privacy_2').is(':checked');
              var profilo_spunta_privacy_3 = $('#popup_2021_profilo_spunta_privacy_3').is(':checked');

              API.post("community/setPrivacy2021AndLoginFanize", {
                profilo_spunta_newsletter: profilo_spunta_newsletter,
                profilo_spunta_privacy_2: profilo_spunta_privacy_2,
                profilo_spunta_privacy_3: profilo_spunta_privacy_3,
                rds_auth_token: resp.user.rds_auth_token,
                userid: resp.user.userid
              }, (r) => {

                if (resp.user.p1 == 1 && r.status == 1) {

                  resp.user.newsletter = profilo_spunta_newsletter ? 1 : 0;
                  resp.user.p2 = profilo_spunta_privacy_2 ? 1 : 0;
                  resp.user.p3 = profilo_spunta_privacy_3 ? 1 : 0;

                  user.saveLocalUser(resp.user);
                  user.checkUser();

                  if (window.location.pathname == '/login' || window.location.pathname == '/profilo') {
                    router.addNavigation("/profilo");
                  }

                }
                // track caffeina
                Utils.setCookie("rds_user_session", resp.user.rds_auth_token, 1);
                eventBus.emit(EVENTS.USER_LOGIN, user.createLoginEventParams());
                resolve();
                return;

              });

            }, () => {

              $(".popup-messaggio-main").hide();
              reject(resp.message);
              return;

            }, "OK", "ANNULLA", () => {

              $("#popup_2021_profilo_spunta_newsletter").attr("checked", resp.user.newsletter == 1);
              $("#popup_2021_profilo_spunta_privacy_2").attr("checked", resp.user.p2 == 1);
              $("#popup_2021_profilo_spunta_privacy_3").attr("checked", resp.user.p3 == 1);

            });

          } else {
            Utils.alertError(resp.message);
            reject(resp.message);
            return;
          }

        } else {

          if (resp.user.p1 == 1) {
            user.saveLocalUser(resp.user);
            user.checkUser();
            if (window.location.pathname == '/login' || window.location.pathname == '/profilo' || window.location.pathname.indexOf("/app/verify") == 0) {
              router.addNavigation(user.getAfterLoginRedirectUrl());;
            }
          }

          Utils.setCookie("rds_user_session", resp.user.rds_auth_token, 1);
          eventBus.emit(EVENTS.USER_LOGIN, user.createLoginEventParams());
          resolve();

        }

      }, function () {
        Utils.hideWaitingLoader();
      });
    });


  }

  loginFacebook() {
    return new Promise((resolve, reject) => {
      FB.login(function (fbloginresp) {
        console.log(fbloginresp);
        if (fbloginresp.status === 'connected') {
          user.loginFacebookAuth(fbloginresp.authResponse, resolve, reject);
        } else {
          Utils.hideWaitingLoader();
          reject();
        }
      }, {
        scope: 'public_profile,email'
      });
    });
  }

  loginFacebookAuth(auth, callbackSucess, callbackError) {

    Utils.showWaitingLoader();

    API.post("community/login/facebook", { accessToken: auth.accessToken }, function (resp) {

      Utils.hideWaitingLoader();

      if (resp.status != 0) {

        if (resp.status == -6) {
          console.log(resp.status);
          // $(".rds-modal-popup-box").css("height", "350px");
          // $("#rds-popup-content").html(window.templates["conferma-privacy-popup"]);
          // RDSMODALPOPUP.open();
          // $(document).on('submit', '#formconfermaprivacy', function (e) {
          //     e.preventDefault();
          //     USER.confirmPrivacy(email, password);
          // });
        } else if (resp.status == -3) {
          router.addNavigation('/registrati', function () {
            // $("#registrati-step-1").hide();
            // $("#registrati-step-2").show();
            $("input#user-name").val(resp.nome);
            if (resp.email) {
              $("input#user-email").val(resp.email).prop("disabled", true);
            }
            if (resp.cognome) {
              $("input#user-cognome").val(resp.cognome);
            }

            // $("#button_registrati").attr("data-type", "fb");
            // $("input#user-password").parents(".form-register-row").hide();
            // $("input#user-password").val("-1");

            $("input[name=fbtoken]").val(auth.accessToken);
          });
        } else if (resp.status == -4) {

          Utils.alertError(resp.message);

        } else if (resp.status == -2021) {

          closeLoginPopup();

          Utils.confirmCustom(TITLE_TERMS_2021, window.templates["termini_condizioni_popup_2021"], () => {

            var profilo_spunta_newsletter = $('#popup_2021_profilo_spunta_newsletter').is(':checked');
            var profilo_spunta_privacy_2 = $('#popup_2021_profilo_spunta_privacy_2').is(':checked');
            var profilo_spunta_privacy_3 = $('#popup_2021_profilo_spunta_privacy_3').is(':checked');

            API.post("community/setPrivacy2021AndLoginFanize", {
              profilo_spunta_newsletter: profilo_spunta_newsletter,
              profilo_spunta_privacy_2: profilo_spunta_privacy_2,
              profilo_spunta_privacy_3: profilo_spunta_privacy_3,
              rds_auth_token: resp.user.rds_auth_token,
              userid: resp.user.userid
            }, (r) => {

              if (resp.user.p1 == 1 && r.status == 1) {

                resp.user.newsletter = profilo_spunta_newsletter ? 1 : 0;
                resp.user.p2 = profilo_spunta_privacy_2 ? 1 : 0;
                resp.user.p3 = profilo_spunta_privacy_3 ? 1 : 0;

                console.log(resp.user);
                user.saveLocalUser(resp.user);
                user.checkUser();

                //TODO: rimuovere e settarlo lato API
                Utils.setCookie("rds_user_session", resp.user.rds_auth_token, 1);
                eventBus.emit(EVENTS.USER_LOGIN, user.createLoginEventParams());
                if (window.location.pathname == '/login' || window.location.pathname == '/registrati' || window.location.pathname == '/profilo') {
                  router.addNavigation("/profilo");
                }

                if (callbackSucess) {
                  callbackSucess();
                }
              }

            });

          }, () => {

            $(".popup-messaggio-main").hide();
            if (callbackError) {
              callbackError();
            }

          }, "OK", "ANNULLA", () => {

            $("#popup_2021_profilo_spunta_newsletter").attr("checked", resp.user.newsletter == 1);
            $("#popup_2021_profilo_spunta_privacy_2").attr("checked", resp.user.p2 == 1);
            $("#popup_2021_profilo_spunta_privacy_3").attr("checked", resp.user.p3 == 1);

          });

        }

        if (callbackError) {
          callbackError();
        }

      } else {

        if (resp.user.p1 == 1) {
          // resp.user.type_login = "fb";
          console.log(resp.user);
          user.saveLocalUser(resp.user);
          user.checkUser();

          if (window.location.pathname == '/login' || window.location.pathname == '/registrati' || window.location.pathname == '/profilo') {
            router.addNavigation(user.getAfterLoginRedirectUrl());;
          }
          eventBus.emit(EVENTS.USER_LOGIN, user.createLoginEventParams());
          if (callbackSucess) {
            callbackSucess();
          }
        }

      }

    }, function () {
      Utils.hideWaitingLoader();
    });

  }

  loginGoogle() {
    return new Promise((resolve, reject) => {
      google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          document.cookie = `g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
          google.accounts.id.prompt();
          googleLoginCb=resolve;
          googleLoginErrorCb=reject;
        }
      });
    });
    // return new Promise((resolve,reject)=>{
    //     var myParams = {
    //         'clientid' : '909974988870-qva3j94plrs1elcqe2qqj0hvavl5ihgh.apps.googleusercontent.com', //You need to set client id
    //         'cookiepolicy' : 'single_host_origin',
    //         'approvalprompt':'force',
    //         'scope' : 'https://www.googleapis.com/auth/plus.login https://www.googleapis.com/auth/plus.profile.emails.read'
    //     };
    //
    //     gapi.auth2.getAuthInstance().signIn(myParams).then(function (googleUser){
    //
    //         var profile = googleUser.getBasicProfile();
    //         console.log('ID: ' + profile.getId());          // Do not send to your backend! Use an ID token instead.
    //         console.log('Name: ' + profile.getGivenName());
    //         console.log('Image URL: ' + profile.getImageUrl());
    //         console.log('Email: ' + profile.getEmail());    // This is null if the 'email' scope is not present.
    //
    //         user.loginGoogleAuth(profile, googleUser.getAuthResponse().id_token, resolve, reject);
    //         // resolve();
    //     }).catch(function (error){
    //         reject(error);
    //         console.log(error);
    //     });
    // });

  }

  loginGoogleAuth(profile, id_token, callbackSucess, callbackError) {

    Utils.showWaitingLoader();
    console.log(profile);
    API.post("community/login/google", profile, function (resp) {

      Utils.hideWaitingLoader();

      if (resp.status != 0) {

        if (resp.status == -6) {
          console.log(resp.status);
          // $(".rds-modal-popup-box").css("height", "350px");
          // $("#rds-popup-content").html(window.templates["conferma-privacy-popup"]);
          // RDSMODALPOPUP.open();
          // $(document).on('submit', '#formconfermaprivacy', function (e) {
          //     e.preventDefault();
          //     USER.confirmPrivacy(email, password);
          // });
        } else if (resp.status == -3) {
          router.addNavigation('/registrati', function () {
            // $("#registrati-step-1").hide();
            // $("#registrati-step-2").show();

            if (resp.email) {
              $("input#user-email").val(resp.email).prop("disabled", true);
            }
            if (resp.cognome) {
              $("input#user-cognome").val(resp.cognome);
            }

            // $("#button_registrati").attr("data-type", "google");
            // $("input#user-password").parents(".form-register-row").hide();
            // $("input#user-password").val("-1");

            $("input#user-name").val(resp.nome);
            $("input#user-email").val(resp.email);
            $("input[name=gtoken]").val(resp.id_token);
          });
        } else if (resp.status == -4) {
          Utils.alertError(resp.message);
        } else if (resp.status == -2021) {

          closeLoginPopup();

          Utils.confirmCustom(TITLE_TERMS_2021, window.templates["termini_condizioni_popup_2021"], () => {

            var profilo_spunta_newsletter = $('#popup_2021_profilo_spunta_newsletter').is(':checked');
            var profilo_spunta_privacy_2 = $('#popup_2021_profilo_spunta_privacy_2').is(':checked');
            var profilo_spunta_privacy_3 = $('#popup_2021_profilo_spunta_privacy_3').is(':checked');

            API.post("community/setPrivacy2021AndLoginFanize", {
              profilo_spunta_newsletter: profilo_spunta_newsletter,
              profilo_spunta_privacy_2: profilo_spunta_privacy_2,
              profilo_spunta_privacy_3: profilo_spunta_privacy_3,
              rds_auth_token: resp.user.rds_auth_token,
              userid: resp.user.userid
            }, (r) => {

              if (resp.user.p1 == 1 && r.status == 1) {

                resp.user.newsletter = profilo_spunta_newsletter ? 1 : 0;
                resp.user.p2 = profilo_spunta_privacy_2 ? 1 : 0;
                resp.user.p3 = profilo_spunta_privacy_3 ? 1 : 0;

                user.saveLocalUser(resp.user);
                user.checkUser();

                //TODO: rimuovere e settarlo lato API
                Utils.setCookie("rds_user_session", resp.user.rds_auth_token, 1);
                eventBus.emit(EVENTS.USER_LOGIN, user.createLoginEventParams());
                if (window.location.pathname == '/login' || window.location.pathname == '/registrati' || window.location.pathname == '/profilo') {
                  router.addNavigation(user.getAfterLoginRedirectUrl());;
                }


                if (callbackSucess) {
                  callbackSucess();
                }
                if(googleLoginCb){
                  googleLoginCb();
                }
              }

            });

          }, () => {

            $(".popup-messaggio-main").hide();
            if (callbackError) {
              callbackError();
            }
            if(googleLoginErrorCb){
              googleLoginErrorCb();
            }

          }, "OK", "ANNULLA", () => {

            $("#popup_2021_profilo_spunta_newsletter").attr("checked", resp.user.newsletter == 1);
            $("#popup_2021_profilo_spunta_privacy_2").attr("checked", resp.user.p2 == 1);
            $("#popup_2021_profilo_spunta_privacy_3").attr("checked", resp.user.p3 == 1);

          });

        }
        if (callbackError) {
          callbackError();
        }

      } else {
        if (resp.user.p1 == 1) {
          // resp.user.type_login = "google";
          user.saveLocalUser(resp.user);
          user.checkUser();

          if (window.location.pathname == '/login' || window.location.pathname == '/registrati' || window.location.pathname == '/profilo') {
            router.addNavigation(user.getAfterLoginRedirectUrl());;
          }
          eventBus.emit(EVENTS.USER_LOGIN, user.createLoginEventParams());
        }
      }

    }, function () {
      Utils.hideWaitingLoader();
    });

  }

  loginAndRedirect(provider, url) {
    if (!provider) {
      throw new Error('no provider');
    }
    let loginFn = user.loginMail;
    switch (provider) {
      case 'facebook':
        loginFn = user.loginFacebook;
        break;
      case 'google':
        loginFn = user.loginGoogle;
        break;
    }
    loginFn().then(() => {
      $(".popup-errore-main").remove();
      $("html").css("overflow-y", 'auto');

      if (url.indexOf("/giochi/") == -1) {
        router.addNavigation(url);
      } else {
        router.addNavigation(url, () => {
          //TODO: fai qualcosa
        });
      }

    }).catch((e) => {
      console.error(e);
      $("html").css("overflow-y", 'auto');
    });
  }

  logout() {
    // if (Utils.confirmCustom("Sei sicuro di voler uscire?")) {
    //     API.get("community/logout", {},  (resp) => {
    //         this.logoutNoConfirm();
    //     });
    // }

    Utils.confirmCustom("Sei sicuro di voler uscire?", "", () => {

      API.get("community/logout", {}, (resp) => {
        this.logoutNoConfirm();
      });

    }, () => {

      $(".popup-messaggio-main").hide();

    }, "SI", "ANNULLA");


  }

  logoutNoConfirm() {
    this.deleteLocalUser();
    eventBus.emit(EVENTS.RENDER_USER_NOT_LOGGED);
    this.checkUser();
    router.addNavigation("/");
    $(".set_preferiti").removeClass("liked");
    eventBus.emit(EVENTS.USER_LOGOUT);
  }

  getLocalUser(sendAutoLoginEvent=false) {
    const rdsUserSession = Utils.getCookie('rds_user_session');
    if (!rdsUserSession) {
      this.deleteLocalUser();
      return;
    }
    try {
      var user = localStorage.getItem("rds_user");
      if (user && JSON.parse(user).rds_auth_token != rdsUserSession) {
        this.deleteLocalUser();
        return null;
      }
      if (user) {
        if (sendAutoLoginEvent){
          eventBus.emit(EVENTS.USER_AUTOLOGIN,)
        }
        return JSON.parse(user);
      } else {
        return null;
      }
    } catch (e) {
      this.deleteLocalUser();
      return null;
    }
  }

  saveLocalUser(user) {
    localStorage.setItem("rds_user", JSON.stringify(user));
  }

  deleteLocalUser() {
    localStorage.removeItem("rds_user");
  }

  checkUser(callback, fallback, sendAutoLoginEvent=false) {

    var user = this.getLocalUser(sendAutoLoginEvent);
    if (user) {

      //Verifica validita del token

      var date_untill = user.valid_untill.date.replace(/\s/, 'T');
      var valid_untill = new Date(date_untill);
      valid_untill.setTime(valid_untill.getTime() + valid_untill.getTimezoneOffset() * -60 * 1000);
      var now = new Date();
      var difference = valid_untill.getTime() - now.getTime();
      var recheck = (difference / 1000) - (3600 * 22);

      if (recheck > 0) {

        // lancio l'evento di utente loggato
        eventBus.emit(EVENTS.RENDER_USER_LOGGED, user);

        if (typeof callback === "function") {
          callback(user);
        }
        return true;
      } else {
        this.deleteLocalUser();
        return this.verifyOnlineUser(callback, fallback);
      }

    } else {
      return this.verifyOnlineUser(callback, fallback);
    }

  }

  verifyOnlineUser(callback, fallback) {

    API.get("community/chekUser", null, (resp) => {

      if (resp.status == 0) {

        this.saveLocalUser(resp.user);

        // lancio l'evento di utente loggato
        eventBus.emit(EVENTS.RENDER_USER_LOGGED, resp.user);

        if (typeof callback === "function") {
          callback(resp.user);
        }

      } else {

        this.deleteLocalUser();

        // lancio l'evento di utente loggato
        eventBus.emit(EVENTS.RENDER_USER_NOT_LOGGED);

        if (typeof fallback === "function") {
          fallback();
        }

      }

    });

    return false;

  }

  recuperaPassword() {

    $("#error-message-email").html("");
    $(".fieldset-email").removeClass("fieldset-error");

    let email = $('#user-email').val();

    if (email.length < 3) {

      $("#error-message-email").html("L' email inserita non è valida");
      $(".fieldset-email").addClass("fieldset-error");
      return false;

    }

    Utils.showWaitingLoader();

    API.post("community/recoverPassword", { email: email }, function (resp) {

      Utils.hideWaitingLoader();

      if (resp.status == -1) {
        $("#error-message-email").html("La mail inserita non e' presente nella community di RDS");
        $(".fieldset-email").addClass("fieldset-error");
      } else if (resp.status == 1) {
        // Utils.alertMessage("Ti abbiamo inviato una email con le istruzioni per il recupero della password", ()=>{
        //   addNavigation("/home");
        // });
        $("#user-email-sended").val(email);
        $(".recover-password.not-sended").slideUp();
        $(".recover-password.sended").slideDown();


        // $("#error-message-email").html("Ti abbiamo inviato una email con le istruzioni per il recupero");
      } else {
        $("#error-message-email").html("Si e' verificato un errore, riprova fra un po'");
        $(".fieldset-email").addClass("fieldset-error");
      }

    });

  }

  recuperaPasswordStep2() {

    let in_error = false;

    $("#error-message-password").html("");
    $("#error-message-password-confirm").html("");

    $(".fieldset-password").removeClass("fieldset-error");
    $(".fieldset-password-confirm").removeClass("fieldset-error");

    if ($('#user-password').val().length < 3) {
      $("#error-message-password").html("il campo password non è valido");
      in_error = true;
    }

    if ($('#user-password-confirm').val().length < 3) {
      $("#error-message-password-confirm").html("il campo conferma password non è valido");
      in_error = true;
    }

    if ($('#user-password').val() != $('#user-password-confirm').val()) {
      $("#error-message-password-confirm").html("i due campi password non coincidono");
      in_error = true;
    }

    if (in_error) {
      return;
    }
    const allParams = location.href.split('?')[1];
    let _token;
    try {
      _token = allParams.split('&login_email')[0].split('token=')[1];
    } catch (error) {
      console.warn(error);
    }

    var data = {
      token: _token || $('#recuperapasswordpostmail_token').val(),
      email: $('#recuperapasswordpostmail_login_email').val(),
      password: $('#user-password').val()
    };

    Utils.showWaitingLoader();

    API.post("user/changePassword", data, function (resp) {

      Utils.hideWaitingLoader();

      if (resp.status == 1) {
        Utils.alertMessage("Nuova password impostata con successo");
        router.addNavigation("/profilo");
      } else {
        $("#error-message-password-confirm").html(resp.message);
      }

    });

  }

  modificaPassword() {

    $(".eye-icon").removeClass("margin-bottom-25");

    let in_error = false;

    $("#error-message-password").html("");
    $("#error-message-old-password").html("");
    $("#error-message-password-confirm").html("");

    $(".fieldset-password").removeClass("fieldset-error");
    $(".fieldset-old-password").removeClass("fieldset-error");
    $(".fieldset-password-confirm").removeClass("fieldset-error");

    let oldpassword = $('#vecchia-password').val();
    let newpassword = $('#nuova-password').val();
    let confirmPassword = $('#conferma-password').val();

    let data = {
      oldpassword: oldpassword,
      newpassword: newpassword
    };

    if (newpassword == "" || newpassword.length < 10) {
      $(".fieldset-password").addClass("fieldset-error");
      $("#error-message-password").html("La password deve essere di almeno 10 caratteri");
      $(".eye-icon").addClass("margin-bottom-25");
      in_error = true;
    }

    if (newpassword != confirmPassword) {
      $(".fieldset-password-confirm").addClass("fieldset-error");
      $("#error-message-password-confirm").html("I due campi password non coincidono");
      in_error = true;
    }

    if (in_error) {
      return;
    }



    API.post("community/modifyPassword", data, function (resp) {



      if (resp.status == 0) {
        Utils.alertMessage("Nuova password impostata correttamente");
        router.addNavigation("/profilo");
        Utils.hideWaitingLoader();

      } else if (resp.status == 1) {
        $("#error-message-password-confirm").html("La vecchia password non è valida");
      } else if (resp.status == -1) {
        $("#error-message-password-confirm").html("Utente non loggato");
      } else {
        $("#error-message-password-confirm").html(resp.message);
      }

    });

  }

  deleteAccount() {

    var elimina_account = "<div class='elimina-account-main'>" +
      "<div id='elimina-account-box'>" +
      "<div class='elimina-account-inside'>" +
      "<div class='x-delete elimina-account-close'>" +
      "<img src='https://media.rds.it/web/web-site-brandnew/svg/icon-close-black.svg'>" +
      "</div>" +
      "<div class='position-center'>" +
      "<div class='font_36 font_34_tablet font_28_mobile sofia_font bold delete-account-title'>Elimina account</div>" +
      "<div class='delete-account-info font_18 sofia_font'>" +
      "<div>Sei sicuro di voler eliminare definitivamente il tuo account?</div>" +
      "</div>" +
      "<div class='delete-account-button flex'>" +
      "<div class='delete-account-procedi font_16 bold button skew'>Procedi</div>" +
      "<div class='delete-account-annulla font_16 bold button skew elimina-account-close'>Annulla</div>" +
      "</div>" +
      "</div>" +
      "</div>" +
      "</div>" +
      "<div class='background-overlay-grey' style='display: block'></div>" +
      "</div>"

    $("#rds-main").append(elimina_account);

    $(document).on("click", ".elimina-account-close", function () {
      $(".elimina-account-main").remove();
    });

    $(document).on("click", ".delete-account-procedi", function () {
      $(".elimina-account-main").remove();
      Utils.showWaitingLoader();
      API.get("community/richiedi_cancellazione_utente", {}, function (resp) {
        API.get("community/logout", {}, function (resp) {

          Utils.alertMessage("Ti è stata inviata una mail per confermare la cancellazione dell'account");
          user.logoutNoConfirm();
        }, function () {
          Utils.hideWaitingLoader();
        });
      }, function () {
        Utils.hideWaitingLoader();
        console.log('errore richiesta cancellazione utente');
      });
    });
  }

  updateAccount() {
    let in_error = false;
    $(".error-message-nome").html("");
    $(".error-message-cognome").html("");
    $(".error-message-email").html("");
    $(".error-message-citta").html("");
    $(".error-message-nascita").html("");
    $(".error-message-telefono").html("");
    $(".error-message-indirizzo").html("");
    $(".error-message-cap").html("");
    $(".error-message-luogo-nascita").html("");
    $(".error-message-provincia").html("");
    $(".error-message-professione").html("");

    $(".fieldset-dati-nome").removeClass("fieldset-error");
    $(".fieldset-dati-cognome").removeClass("fieldset-error");
    $(".fieldset-dati-email").removeClass("fieldset-error");
    $(".fieldset-dati-citta").removeClass("fieldset-error");
    $(".fieldset-dati-nascita").removeClass("fieldset-error");
    $(".fieldset-dati-telefono").removeClass("fieldset-error");
    $(".fieldset-dati-indirizzo").removeClass("fieldset-error");
    $(".fieldset-dati-cap").removeClass("fieldset-error");
    $(".fieldset-dati-luogo-nascita").removeClass("fieldset-error");
    $(".fieldset-dati-provincia").removeClass("fieldset-error");
    $(".fieldset-dati-professione").removeClass("fieldset-error");

    let nome = $('input[name=blocco_dati_nome_input]').val();
    let cognome = $('input[name=blocco_dati_cognome_input]').val();
    let email = $('input[name=blocco_dati_email_input]').val();
    let email_old = $('input[name=blocco_dati_email_old_input]').val();
    let citta = $('input[name=blocco_dati_citta_input]').val();
    let nascita = $('input[name=blocco_dati_nascita_input]').val();
    let telefono = $('input[name=blocco_dati_telefono_input]').val();
    let indirizzo = $('input[name=blocco_dati_indirizzo_input]').val();
    let cap = $('input[name=blocco_dati_cap_input]').val();
    let luogo_nascita = $('input[name=blocco_dati_luogo_nascita_input]').val();
    let provincia = $('input[name=blocco_dati_provincia_input]').val();
    let professione = $('input[name=blocco_dati_professione_input]').val();

    let extra_musica = $('.choose_profilo.musica.selected').html();
    let extra_interessi = $('.choose_profilo.interessi.selected').html();

    let profilo_spunta_newsletter = $('#profilo_spunta_newsletter').is(':checked');
    let profilo_spunta_privacy_2 = $('#profilo_spunta_privacy_2').is(':checked');
    let profilo_spunta_privacy_3 = $('#profilo_spunta_privacy_3').is(':checked');

    if (nome.length < 3) {
      $(".fieldset-dati-nome").addClass("fieldset-error");
      $("#error-message-nome").html("Il nome non è valido");
      in_error = true;
    }

    if (cognome.length < 3) {
      $(".fieldset-dati-cognome").addClass("fieldset-error");
      $("#error-message-cognome").html("Il cognome non è valido");
      in_error = true;
    }

    /*
          if (telefono.length < 3) {
              $(".fieldset-dati-telefono").addClass("fieldset-error");
              $("#error-message-telefono").html("Il numero di telefono non è valido");
              in_error = true;
          }

          if (nascita.length < 3) {
              $(".fieldset-dati-nascita").addClass("fieldset-error");
              $("#error-message-nascita").html("La data di nascita inserita non è valida.");
              in_error = true;
          }

          if (citta.length < 3) {
              $(".fieldset-dati-citta").addClass("fieldset-error");
              $("#error-message-citta").html("La città inserita non è valida");
              in_error = true;
          }
  */
    if (in_error) {
      return;
    }

    if (email != email_old)
      Utils.alertMessage("Conferma la mail cliccando sul link che ti abbiamo inviato al tuo attuale indirizzo");

    var formData = new FormData();

    formData.set('email', email);
    formData.set('oldEmail', email_old);
    formData.set('nome', nome);
    formData.set('cognome', cognome);
    formData.set('email', email);
    formData.set('citta', citta);
    formData.set('nascita', nascita);
    formData.set('telefono', telefono);
    formData.set('indirizzo', indirizzo);
    formData.set('cap', cap);
    formData.set('luogo_nascita', luogo_nascita);
    formData.set('provincia', provincia);
    formData.set('extra[professione]', professione);

    formData.set('newsletter', profilo_spunta_newsletter ? 1 : 0);
    formData.set('privacy_2', profilo_spunta_privacy_2 ? 1 : 0);
    formData.set('privacy_3', profilo_spunta_privacy_3 ? 1 : 0);

    formData.set('extra[musica]', extra_musica);
    formData.set('extra[interessi]', extra_interessi);

    Utils.showWaitingLoader();

    API.postFormData("community/editProfile", formData, function (resp) {

      Utils.hideWaitingLoader();

      if (resp.status == 0) {
        $("#indietro_modifica").trigger("click");
        user.saveLocalUser(resp.user)
        user.checkUser();
        eventBus.emit(EVENTS.RENDER_USER_LOGGED, resp.user);

        $("#blocco_dati_nome_label").html(nome);
        $("#blocco_dati_cognome_label").html(cognome);
        $("#blocco_dati_citta_label").html(citta);
        $("#blocco_dati_nascita_label").html(nascita);
        $("#blocco_dati_telefono_label").html(telefono);
        $("#blocco_dati_indirizzo_label").html(indirizzo);
        $("#blocco_dati_cap_label").html(cap);
        $("#blocco_dati_luogo_nascita_label").html(luogo_nascita);
        $("#blocco_dati_provincia_label").html(provincia);
        $("#blocco_dati_professione_label").html(professione);

      } else {
        Utils.alertError("La sessione è scaduta, per continuare devi loggarti di nuovo");
        user.logoutNoConfirm();
      }

    }, function () {
      Utils.hideWaitingLoader();
      Utils.alertError("Errore durante la modifica dei campi");
    });

  }

  changeAvatar() {

    var formData = new FormData();
    var myFileInput = document.getElementById("file-change-avatar");
    formData.append('file-change-avatar', myFileInput.files[0], myFileInput.files[0].name);

    Utils.showWaitingLoader();

    API.postFormData("community/changeAvatar", formData, function (resp) {

      Utils.hideWaitingLoader();

      if (resp.status == 0) {
        user.saveLocalUser(resp.user)
        user.checkUser();
        eventBus.emit(EVENTS.RENDER_USER_LOGGED, resp.user);
        $("#immagine_profilo").attr("src", resp.user.avatar);
      }

    }, function () {
      Utils.hideWaitingLoader();
      Utils.alertError("Errore durante la modifica dell'immagine");
    });

  }

  checkUserLogged(type) {
    var redirect = type == 'gioca' ? '/gioca' : '/richiedi_scherzo';
    var popup_log_in = `
        <div class='popup-errore-main'>
            <div id='popup-errore-box' class='popup-login-box' style='transform: translate(-50%, -50%)'>
                <div class='x-delete elimina-account-close'><img
                    src='https://media.rds.it/web/web-site-brandnew/svg/icon-close-black.svg'></div>
                <div class='popup-errore-inside'><span
                    class='register-title sofia_font font_36 font_34_tablet font_28_mobile'>Accedi</span>
                <div class='form-register flex' style='margin-bottom: 0'>
                    <div onclick="user.loginAndRedirect('facebook', '${redirect}');"
                    class='form-register-row row-facebook flex clickable'>
                    <div class='img-box'><img src='https://media.rds.it/web/web-site-brandnew/svg/fb-icon.svg'></div>
                    <div class='register-icon-box font_14'><span>Continua con Facebook</span></div>
                    </div>
                    <div onclick="user.loginAndRedirect('google', '${redirect}');"
                    class='form-register-row row-google flex clickable'>
                    <div class='img-box'><img src='https://media.rds.it/web/web-site-brandnew/svg/google-icon.svg'></div>
                    <div class='register-icon-box font_14'><span>Continua con Google</span></div>
                    </div>
                    <div class='form-register-row row-text'>
                    <hr><span class='sofia_font'>oppure</span>
                    <hr>
                    </div>
                    <div class='form-register-input flex'>
                    <div class='form-register-row flex'>
                        <div class='register-input-row'>
                        <fieldset class='fieldset-gray fieldset-email'>
                            <legend>Email</legend>
                            <div class='flex align_center'><input id='user-email' name='user-email' class='register-input font_16'
                                type='text' value='' placeholder='Inserisci la tua email'><img class='icon-error'
                                src='https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg'></div>
                        </fieldset>
                        <div id='error-message-email' class='error-message-email error-messages font-size-14 sofia_font'></div>
                        </div>
                    </div>
                    <div class='form-register-row flex'>
                        <div class='register-input-row'>
                        <fieldset class='fieldset-gray fieldset-password'>
                            <legend>Password</legend>
                            <div class='flex align_center'><input id='user-password' name='user-password'
                                class='register-input font_16' type='password' value='' placeholder='Inserisci la tua password'><img
                                class='icon-error' src='https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg'></div>
                        </fieldset>
                        <div id='error-message-password' class='error-message-password error-messages font-size-14 sofia_font'></div>
                        </div>
                    </div>
                    <div onclick="user.loginAndRedirect('mail', '${redirect}');"
                        class='form-register-row row-email flex clickable'>
                        <div class='register-icon-box'><span id='accedi-button' class='upper-text'>accedi</span></div>
                    </div>
                    </div>
                    <div class='info-enter'>
                    <p class='font_18 clickable color_blue semi_bold'><a href='/registrati'>Non hai un account?
                        Registrati</a><br><a href='/recupera-password'>Password dimenticata</a></p>
                    </div>
                </div>
                </div>
            </div>
            <div class='background-overlay-grey' style='display: block'></div>
        </div>`;
    $('body').append(popup_log_in);
    // $("html").css('overflow-y', 'hidden');

    $(document).on("click", ".x-delete", function () {
      $(".popup-errore-main").remove();
      // $("html").css("overflow-y", 'auto');
    });
  }


  // LIKE RED HEART PART
  loginAfterLike(provider) {
    if (!provider) {
      throw new Error('no provider');
    }
    let loginFn = user.loginMail;
    switch (provider) {
      case 'facebook':
        loginFn = user.loginFacebook;
        break;
      case 'google':
        loginFn = user.loginGoogle;
        break;
    }
    loginFn().then(() => {
      window.setMyFavorite();
      var id_elem = $(".popup-errore-main").attr("data-id");
      var type = $(".popup-errore-main").attr("data-type");
      var mastercontrol_id = $(".popup-errore-main").attr("data-masterid");
      //se non c'è la classe liked, simulo il click
      setTimeout(function () {
        if (!$(".container_set_preferito[data-id='" + id_elem + "'][data-type='" + type + "']").find(".set_preferiti").hasClass("liked")) {
          $(".container_set_preferito[data-id='" + id_elem + "'][data-type='" + type + "']").find(".set_preferiti").first().trigger("click");
        }
      }, 2000);
      closeLoginPopup();
      // window.setMyFavorite();
      // var id_elem = $(".popup-errore-main").attr("data-id");
      // var type = $(".popup-errore-main").attr("data-type");
      // var mastercontrol_id = $(".popup-errore-main").attr("data-masterid");
      // $(".popup-errore-main").remove();
      //     //se non c'è la classe liked, simulo il click
      // if(!$(".container_set_preferito[data-id='" + id_elem + "'][data-type='" + type + "']").find(".set_preferiti").hasClass("liked")){
      //     $(".container_set_preferito[data-id='" + id_elem + "'][data-type='" + type + "']").find(".set_preferiti").first().trigger("click");
      // }
      // $("html").css("overflow-y", 'auto');
    }).catch(() => {
      $("html").css("overflow-y", 'auto');
    });
  }

  checkUser_preferiti(id_elem, type, add_like, mastercontrol_id) {
    var popup_log_in = `
        <div class='popup-errore-main'>
            <div id='popup-errore-box' class='popup-login-box' style='transform: translate(-50%, -50%)'>
                <div class='x-delete elimina-account-close'><img
                    src='https://media.rds.it/web/web-site-brandnew/svg/icon-close-black.svg'></div>
                <div class='popup-errore-inside'><span
                    class='register-title sofia_font font_36 font_34_tablet font_28_mobile'>Accedi</span>
                <div class='form-register flex' style='margin-bottom: 0'>
                    <div onclick="user.loginAfterLike('facebook');"
                    class='form-register-row row-facebook flex clickable'>
                    <div class='img-box'><img src='https://media.rds.it/web/web-site-brandnew/svg/fb-icon.svg'></div>
                    <div class='register-icon-box font_14'><span>Continua con Facebook</span></div>
                    </div>
                    <div onclick="user.loginAfterLike('google');"
                    class='form-register-row row-google flex clickable'>
                    <div class='img-box'><img src='https://media.rds.it/web/web-site-brandnew/svg/google-icon.svg'></div>
                    <div class='register-icon-box font_14'><span>Continua con Google</span></div>
                    </div>
                    <div class='form-register-row row-text'>
                    <hr><span class='sofia_font'>oppure</span>
                    <hr>
                    </div>
                    <div class='form-register-input flex'>
                    <div class='form-register-row flex'>
                        <div class='register-input-row'>
                        <fieldset class='fieldset-gray fieldset-email'>
                            <legend>Email</legend>
                            <div class='flex align_center'><input id='user-email' name='user-email' class='register-input font_16'
                                type='text' value='' placeholder='Inserisci la tua email'><img class='icon-error'
                                src='https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg'></div>
                        </fieldset>
                        <div id='error-message-email' class='error-message-email error-messages font-size-14 sofia_font'></div>
                        </div>
                    </div>
                    <div class='form-register-row flex'>
                        <div class='register-input-row'>
                        <fieldset class='fieldset-gray fieldset-password'>
                            <legend>Password</legend>
                            <div class='flex align_center'><input id='user-password' name='user-password'
                                class='register-input font_16' type='password' value='' placeholder='Inserisci la tua password'><img
                                class='icon-error' src='https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg'></div>
                        </fieldset>
                        <div id='error-message-password' class='error-message-password error-messages font-size-14 sofia_font'></div>
                        </div>
                    </div>
                    <div onclick="user.loginAfterLike('mail');"
                        class='form-register-row row-email flex clickable'>
                        <div class='register-icon-box'><span id='accedi-button' class='upper-text'>accedi</span></div>
                    </div>
                    </div>
                    <div class='info-enter'>
                    <p class='font_18 clickable color_blue semi_bold'><a href='/registrati'>Non hai un account?
                        Registrati</a><br><a href='/recupera-password'>Password dimenticata</a></p>
                    </div>
                </div>
                </div>
            </div>
            <div class='background-overlay-grey' style='display: block'></div>
        </div>`;
    $("#rds-main").append(popup_log_in);
    $(".popup-errore-main").attr("data-type", type);
    $(".popup-errore-main").attr("data-id", id_elem);
    $(".popup-errore-main").attr("data-like", add_like);
    $(".popup-errore-main").attr("data-masterid", mastercontrol_id);
    // $("html").css('overflow-y', 'hidden');

    $(document).on("click", ".x-delete", function () {
      $(".popup-errore-main").remove();
      // $("html").css("overflow-y", 'auto');
    });
  }


  // Richiedi scherzo accesso dall'URL
  loginRichiediScherzo(provider) {
    if (!provider) {
      throw new Error('no provider');
    }
    let loginFn = user.loginMail;
    switch (provider) {
      case 'facebook':
        loginFn = user.loginFacebook;
        break;
      case 'google':
        loginFn = user.loginGoogle;
        break;
    }
    loginFn().then(() => {
      $(".popup-errore-main").remove();
      $("html").css("overflow-y", 'auto');
    }).catch(() => {
      $("html").css("overflow-y", 'auto');
    });
  }


  popUpRichiediScherzo() {
    var popup_log_in = `
        <div class='popup-errore-main'>
            <div id='popup-errore-box' class='popup-login-box' style='transform: translate(-50%, -50%)'>
                <div class='x-delete elimina-account-close'><img
                    src='https://media.rds.it/web/web-site-brandnew/svg/icon-close-black.svg'></div>
                <div class='popup-errore-inside'><span
                    class='register-title sofia_font font_36 font_34_tablet font_28_mobile'>Accedi</span>
                <div class='form-register flex' style='margin-bottom: 0'>
                    <div onclick="user.loginRichiediScherzo('facebook');"
                    class='form-register-row row-facebook flex clickable'>
                    <div class='img-box'><img src='https://media.rds.it/web/web-site-brandnew/svg/fb-icon.svg'></div>
                    <div class='register-icon-box font_14'><span>Continua con Facebook</span></div>
                    </div>
                    <div onclick="user.loginRichiediScherzo('google');"
                    class='form-register-row row-google flex clickable'>
                    <div class='img-box'><img src='https://media.rds.it/web/web-site-brandnew/svg/google-icon.svg'></div>
                    <div class='register-icon-box font_14'><span>Continua con Google</span></div>
                    </div>
                    <div class='form-register-row row-text'>
                    <hr><span class='sofia_font'>oppure</span>
                    <hr>
                    </div>
                    <div class='form-register-input flex'>
                    <div class='form-register-row flex'>
                        <div class='register-input-row'>
                        <fieldset class='fieldset-gray fieldset-email'>
                            <legend>Email</legend>
                            <div class='flex align_center'><input id='user-email' name='user-email' class='register-input font_16'
                                type='text' value='' placeholder='Inserisci la tua email'><img class='icon-error'
                                src='https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg'></div>
                        </fieldset>
                        <div id='error-message-email' class='error-message-email error-messages font-size-14 sofia_font'></div>
                        </div>
                    </div>
                    <div class='form-register-row flex'>
                        <div class='register-input-row'>
                        <fieldset class='fieldset-gray fieldset-password'>
                            <legend>Password</legend>
                            <div class='flex align_center'><input id='user-password' name='user-password'
                                class='register-input font_16' type='password' value='' placeholder='Inserisci la tua password'><img
                                class='icon-error' src='https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg'></div>
                        </fieldset>
                        <div id='error-message-password' class='error-message-password error-messages font-size-14 sofia_font'></div>
                        </div>
                    </div>
                    <div onclick="user.loginRichiediScherzo('mail');"
                        class='form-register-row row-email flex clickable'>
                        <div class='register-icon-box'><span id='accedi-button' class='upper-text'>accedi</span></div>
                    </div>
                    </div>
                    <div class='info-enter'>
                    <p class='font_18 clickable color_blue semi_bold'><a href='/registrati'>Non hai un account?
                        Registrati</a><br><a href='/recupera-password'>Password dimenticata</a></p>
                    </div>
                </div>
                </div>
            </div>
            <div class='background-overlay-grey' style='display: block'></div>
        </div>`;
    $("#rds-main").append(popup_log_in);
    $("html").css('overflow-y', 'hidden');

    $(document).on("click", ".x-delete", function () {
      $(".popup-errore-main").remove();
      $("html").css("overflow-y", 'auto');
    });
  }

  openLoginPopupGame(url) {

    console.log(url);
    var popup_log_in = `
        <div class='popup-errore-main'>
            <div id='popup-errore-box' class='popup-login-box' style='transform: translate(-50%, -50%)'>
                <div class='x-delete elimina-account-close'><img
                    src='https://media.rds.it/web/web-site-brandnew/svg/icon-close-black.svg'></div>
                <div class='popup-errore-inside'><span
                    class='register-title sofia_font font_36 font_34_tablet font_28_mobile'>Accedi</span>
                <div class='form-register flex' style='margin-bottom: 0'>
                    <div onclick="user.loginAndRedirect('facebook', '` + url + `');"
                    class='form-register-row row-facebook flex clickable'>
                    <div class='img-box'><img src='https://media.rds.it/web/web-site-brandnew/svg/fb-icon.svg'></div>
                    <div class='register-icon-box font_14'><span>Continua con Facebook</span></div>
                    </div>
                    <div onclick="user.loginAndRedirect('google', '` + url + `');"
                    class='form-register-row row-google flex clickable'>
                    <div class='img-box'><img src='https://media.rds.it/web/web-site-brandnew/svg/google-icon.svg'></div>
                    <div class='register-icon-box font_14'><span>Continua con Google</span></div>
                    </div>
                    <div class='form-register-row row-text'>
                    <hr><span class='sofia_font'>oppure</span>
                    <hr>
                    </div>
                    <div class='form-register-input flex'>
                    <div class='form-register-row flex'>
                        <div class='register-input-row'>
                        <fieldset class='fieldset-gray fieldset-email'>
                            <legend>Email</legend>
                            <div class='flex align_center'><input id='user-email' name='user-email' class='register-input font_16'
                                type='text' value='' placeholder='Inserisci la tua email'><img class='icon-error'
                                src='https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg'></div>
                        </fieldset>
                        <div id='error-message-email' class='error-message-email error-messages font-size-14 sofia_font'></div>
                        </div>
                    </div>
                    <div class='form-register-row flex'>
                        <div class='register-input-row'>
                        <fieldset class='fieldset-gray fieldset-password'>
                            <legend>Password</legend>
                            <div class='flex align_center'><input id='user-password' name='user-password'
                                class='register-input font_16' type='password' value='' placeholder='Inserisci la tua password'><img
                                class='icon-error' src='https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg'></div>
                        </fieldset>
                        <div id='error-message-password' class='error-message-password error-messages font-size-14 sofia_font'></div>
                        </div>
                    </div>
                    <div onclick="user.loginAndRedirect('mail', '` + url + `');"
                        class='form-register-row row-email flex clickable'>
                        <div class='register-icon-box'><span id='accedi-button' class='upper-text'>accedi</span></div>
                    </div>
                    </div>
                    <div class='info-enter'>
                    <p class='font_18 clickable color_blue semi_bold'><a href='/registrati'>Non hai un account?
                        Registrati</a><br><a href='/recupera-password'>Password dimenticata</a></p>
                    </div>
                </div>
                </div>
            </div>
            <div class='background-overlay-grey' style='display: block'></div>
        </div>`;
    $("#rds-main").append(popup_log_in);

    $(document).on("click", ".x-delete", function () {
      $(".popup-errore-main").remove();
    });

  }

  openPopupLoginAndCallback(fn, args) {
    window.popupLoginCallback = { fn, args };
    var popup_log_in = `
        <div class='popup-errore-main'>
            <div id='popup-errore-box' class='popup-login-box' style='transform: translate(-50%, -50%)'>
                <div class='x-delete elimina-account-close'><img
                    src='https://media.rds.it/web/web-site-brandnew/svg/icon-close-black.svg'></div>
                <div class='popup-errore-inside'><span
                    class='register-title sofia_font font_36 font_34_tablet font_28_mobile'>Accedi</span>
                <div class='form-register flex' style='margin-bottom: 0'>
                    <div onclick="user.loginAndCallback('facebook');"
                    class='form-register-row row-facebook flex clickable'>
                    <div class='img-box'><img src='https://media.rds.it/web/web-site-brandnew/svg/fb-icon.svg'></div>
                    <div class='register-icon-box font_14'><span>Continua con Facebook</span></div>
                    </div>
                    <div onclick="user.loginAndCallback('google');"
                    class='form-register-row row-google flex clickable'>
                    <div class='img-box'><img src='https://media.rds.it/web/web-site-brandnew/svg/google-icon.svg'></div>
                    <div class='register-icon-box font_14'><span>Continua con Google</span></div>
                    </div>
                    <div class='form-register-row row-text'>
                    <hr><span class='sofia_font'>oppure</span>
                    <hr>
                    </div>
                    <div class='form-register-input flex'>
                    <div class='form-register-row flex'>
                        <div class='register-input-row'>
                        <fieldset class='fieldset-gray fieldset-email'>
                            <legend>Email</legend>
                            <div class='flex align_center'><input id='user-email' name='user-email' class='register-input font_16'
                                type='text' value='' placeholder='Inserisci la tua email'><img class='icon-error'
                                src='https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg'></div>
                        </fieldset>
                        <div id='error-message-email' class='error-message-email error-messages font-size-14 sofia_font'></div>
                        </div>
                    </div>
                    <div class='form-register-row flex'>
                        <div class='register-input-row'>
                        <fieldset class='fieldset-gray fieldset-password'>
                            <legend>Password</legend>
                            <div class='flex align_center'><input id='user-password' name='user-password'
                                class='register-input font_16' type='password' value='' placeholder='Inserisci la tua password'><img
                                class='icon-error' src='https://media.rds.it/web/web-site-brandnew/svg/icon-error.svg'></div>
                        </fieldset>
                        <div id='error-message-password' class='error-message-password error-messages font-size-14 sofia_font'></div>
                        </div>
                    </div>
                    <div onclick="user.loginAndCallback('mail');"
                        class='form-register-row row-email flex clickable'>
                        <div class='register-icon-box'><span id='accedi-button' class='upper-text'>accedi</span></div>
                    </div>
                    </div>
                    <div class='info-enter'>
                    <p class='font_18 clickable color_blue semi_bold'><a href='/registrati'>Non hai un account?
                        Registrati</a><br><a href='/recupera-password'>Password dimenticata</a></p>
                    </div>
                </div>
                </div>
            </div>
            <div class='background-overlay-grey' style='display: block'></div>
        </div>`;
    $("#rds-main").append(popup_log_in);

    $(document).on("click", ".x-delete", function () {
      $(".popup-errore-main").remove();
    });

  }

  loginAndCallback(provider) {

    let fn = popupLoginCallback.fn;
    let args = popupLoginCallback.args;
    if (!popupLoginCallback) {
      console.error("Popup Callback non definito");
    }

    if (!provider) {
      throw new Error('no provider');
    }
    let loginFn = user.loginMail;
    switch (provider) {
      case 'facebook':
        loginFn = user.loginFacebook;
        break;
      case 'google':
        loginFn = user.loginGoogle;
        break;
    }
    loginFn().then(() => {
      $(".popup-errore-main").remove();
      $("html").css("overflow-y", 'auto');

      fn.apply(this, args);

    }).catch((e) => {
      console.log(e);
      $("html").css("overflow-y", 'auto');
    });
  };

  decidiPassword() {

    $(".eye-icon").removeClass("margin-bottom-25");

    let in_error = false;

    $("#error-message-password").html("");

    $("#error-message-password-confirm").html("");

    $(".fieldset-password").removeClass("fieldset-error");

    $(".fieldset-password-confirm").removeClass("fieldset-error");


    if ($('#recupera-password1').val().length < 3) {
      $(".fieldset-password").addClass("fieldset-error");
      $("#error-message-password").html("La nuova password non è valida");
      in_error = true;
    }

    if ($('#recupera-password2').val().length < 3) {
      $(".fieldset-password-confirm").addClass("fieldset-error");
      $("#error-message-password-confirm").html("La nuova password non è valida");
      in_error = true;
    }

    if ($('#recupera-password1').val() != $('#recupera-password2').val()) {
      $(".fieldset-password-confirm").addClass("fieldset-error");
      $("#error-message-password-confirm").html("I due campi password non coincidono");
      in_error = true;
    }

    if (in_error) {
      return;
    }



    var password = $('#recupera-password1').val();
    var token = $('#recuperapasswordpostmail_token').val();
    var login_email = $('#recuperapasswordpostmail_login_email').val();

    var data = {
      token: token,
      email: login_email,
      newpassword: password
    };

    Utils.showWaitingLoader();

    API.post("community/addPassword", data, function (resp) {
      Utils.hideWaitingLoader();
      if (resp.status == 1) {
        alertError("Password impostata con successo!");
        router.addNavigation("/login");


      } else if (resp.message == "notfound") {
        alertError("Hai già impostato la tua password");
      } else {
        alertError("Si è verificato un errore, si prega di riprovare");
      }
    });

  };

  richiediPremio() {

    $(".fieldset-riscatta-nome").removeClass("fieldset-error");
    $(".fieldset-riscatta-cognome").removeClass("fieldset-error");
    $(".fieldset-riscatta-telefono").removeClass("fieldset-error");
    $(".fieldset-riscatta-indirizzo").removeClass("fieldset-error");
    $(".fieldset-riscatta-civico").removeClass("fieldset-error");
    $(".fieldset-riscatta-citta").removeClass("fieldset-error");
    $(".fieldset-riscatta-provincia").removeClass("fieldset-error");
    $(".fieldset-riscatta-cap").removeClass("fieldset-error");

    var rewardId = $("#rewardId").val();

    let in_error = false;

    var nome = $("#user-riscatta-nome").val();
    var cognome = $("#user-riscatta-cognome").val();
    var telefono = $("#user-riscatta-telefono").val();
    var indirizzo = $("#user-riscatta-indirizzo").val();
    var civico = $("#user-riscatta-civico").val();
    var citta = $("#user-riscatta-citta").val();

    var provincia = $('select#user-riscatta-provincia option:selected').val();

    var cap = $("#user-riscatta-cap").val();

    if (nome == "") {
      $(".fieldset-riscatta-nome").addClass("fieldset-error");
      in_error = true;
    }

    if (cognome == "") {
      $(".fieldset-riscatta-cognome").addClass("fieldset-error");
      in_error = true;
    }

    if (telefono == "") {
      $(".fieldset-riscatta-telefono").addClass("fieldset-error");
      in_error = true;
    }

    if (indirizzo == "") {
      $(".fieldset-riscatta-indirizzo").addClass("fieldset-error");
      in_error = true;
    }

    if (civico == "") {
      $(".fieldset-riscatta-civico").addClass("fieldset-error");
      in_error = true;
    }

    if (citta == "") {
      $(".fieldset-riscatta-citta").addClass("fieldset-error");
      in_error = true;
    }

    if (provincia == "") {
      $(".fieldset-riscatta-provincia").addClass("fieldset-error");
      in_error = true;
    }

    if (cap == "") {
      $(".fieldset-riscatta-cap").addClass("fieldset-error");
      in_error = true;
    }

    if (in_error) {
      return;
    }

    Utils.showWaitingLoader();

    API.post("community/richiediPremioFanize", {
      rewardId: rewardId,
      nome: nome,
      cognome: cognome,
      telefono: telefono,
      indirizzo: indirizzo,
      civico: civico,
      citta: citta,
      provincia: provincia,
      cap: cap
    }, function (resp) {

      Utils.hideWaitingLoader();
      $(".popup-errore-main").remove();
      Utils.confirmRiscattoPremio("Richiesta inviata!", "Ti abbiamo mandato una mail con tutto ciò che c’è da sapere!", "", "CHIUDI")
      console.log(resp);

    });

  }

}




function closeLoginPopup() {
  $(".popup-errore-main").remove();
  $("html").css("overflow-y", 'auto');
}

window.user = new Users();
window.decidiPassword = user.decidiPassword;
$(document).on('click', '#icon-hidden-pass', (e) => {
  $("#vecchia-password").attr('type', 'password');
  $("#user-password").attr('type', 'password');
  $("#icon-hidden-pass").hide();
  $("#icon-show-pass").show();
});

$(document).on('click', '#icon-show-pass', (e) => {
  $("#vecchia-password").attr('type', 'text');
  $("#user-password").attr('type', 'text');
  $("#icon-hidden-pass").show();
  $("#icon-show-pass").hide();
});


